module.exports = __webpack_public_path__ + "img/112.906db17c.jpg";